import React from 'react';
import Header from '../layouts/Header';
import Footer from '../layouts/Footer';
import AppVersionManager from '../components/AppVersionManager';

export default function AppVersionManagement() {
  return (
    <>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <div className="container-fluid">
          <AppVersionManager />
        </div>
      </div>
      <Footer />
    </>
  );
}